module.exports = __webpack_public_path__ + "img/horizontal_4_4_5010.478068f3.png";